import React, { useLayoutEffect, useRef } from 'react';
import { render } from 'react-dom';
import { hooks } from 'botframework-webchat-component';
const { useStyleOptions } = hooks;
const Nub = ({ fill, nubSize, stroke, strokeWidth }) => {
    const halfStrokeWidth = strokeWidth / 2;
    const p1 = [nubSize, halfStrokeWidth].join(' ');
    const p2 = [strokeWidth, halfStrokeWidth].join(' ');
    const p3 = [nubSize + strokeWidth, nubSize + halfStrokeWidth].join(' ');
    const becomeParentElement = (element) => {
        var _a;
        (_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.replaceWith(element);
    };
    return (React.createElement("svg", { className: "webchat__bubble__nub", fill: fill, ref: becomeParentElement, stroke: stroke, strokeWidth: strokeWidth, version: "1.1", viewBox: `0 0 ${nubSize} ${nubSize}`, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: `M${p1} L${p2} L${p3}` })));
};
export const bffNubInjectorActivityMiddleware = () => (next) => (card) => {
    return card.activity.type !== 'message' || card.activity.from.role !== 'bot'
        ? next(card)
        : (...children) => {
            const wrapperEl = useRef(null);
            const [{ bubbleBorderColor, bubbleBorderWidth, bubbleNubSize, bubbleBackground }] = useStyleOptions();
            useLayoutEffect(() => {
                if (wrapperEl.current != null && bubbleNubSize) {
                    const bubbleContents = wrapperEl.current.querySelectorAll('div.webchat__bubble.webchat__bubble--hide-nub.webchat__bubble--nub-on-top > div.webchat__bubble__content');
                    bubbleContents.forEach((bubbleContent) => {
                        var _a;
                        const container = document.createElement('span');
                        bubbleContent.insertAdjacentElement('afterend', container);
                        const attachmentBubble = bubbleContent.parentElement;
                        attachmentBubble === null || attachmentBubble === void 0 ? void 0 : attachmentBubble.classList.add('webchat__bubble_has_nub');
                        (_a = attachmentBubble === null || attachmentBubble === void 0 ? void 0 : attachmentBubble.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('webchat__stacked_item_indented');
                        render(React.createElement(React.StrictMode, null,
                            React.createElement(Nub, { fill: bubbleBackground, nubSize: bubbleNubSize, stroke: bubbleBorderColor, strokeWidth: bubbleBorderWidth })), container);
                    });
                }
            }, []);
            return React.createElement("span", { ref: wrapperEl }, next(card)(...children));
        };
};
//# sourceMappingURL=bffNubInjectorActivityMiddleware.js.map